<template>
    <v-row class="align-center mt-12 pa-0 ma-0" v-if="page_count > 0">
        <div class="d-none d-sm-none d-md-block">
            <label style="font-weight: 300; font-size: .8125rem; line-height: 1.5; color: #646669;">К-сть записів на сторінці</label>
            <div style="min-width: 150px !important; max-width: 150px !important;">
            <v-select dense :items="[4, 10, 20, 50]" v-model="items_per_page_input"></v-select>
            </div>
        </div>
        <v-spacer class="d-none d-sm-none d-md-block"></v-spacer>
        <v-row class="ma-0 pa-0 align-center">
            <v-col :cols="12" :sm="2" :md="2" :lg="3" class="pa-0">
                <a class="paginate_button-next" @click="paginationPrevPage">
                    <v-row class="align-center justify-center justify-sm-start justify-lg-center">
                        <div class="d-none d-sm-inline paginate_button-prev-icon"></div>
                        <span style="line-height: 1.5;" class="paginate_button-text d-none d-sm-none d-md-none d-lg-flex" v-if="!button_text_hidden">Попередня сторінка</span>
                    </v-row>
                </a>
            </v-col>
            <v-col :cols="12" :sm="8" :md="8" :lg="6" class="pa-0">
                <v-pagination
                    v-model="current_page_input"
                    class="ma-0"
                    :length="page_count"
                    circle
                    elevation="0"
                    total-visible="7"
                ></v-pagination>
            </v-col>
            <v-col :cols="12" :sm="2" :md="2" :lg="3" class="pa-0 pt-5 align-center d-block d-sm-none" v-if="page_count > 2">
                <v-row class="align-center justify-center justify-sm-end justify-lg-center">
                    <v-btn :disabled="current_page == 1" elevation="0" class="d-flex d-sm-none diia-button-style-4" v-if="!button_text_hidden">Попередня</v-btn>
                    <v-btn :disabled="current_page == page_count" elevation="0" class="ml-5 d-flex d-sm-none diia-button-style-4" v-if="!button_text_hidden">Наступна</v-btn>
                </v-row>
            </v-col>
            <v-col :cols="12" :sm="2" :md="2" :lg="3" class="pa-0 align-center">
                <a class="paginate_button-next" @click="paginationNextPage">
                    <v-row class="align-center justify-center justify-sm-end justify-lg-center">
                        <span style="line-height: 1.5;" class="paginate_button-text d-none d-sm-none d-md-none d-lg-flex" v-if="!button_text_hidden">Наступна сторінка</span>
                        <div class="d-none d-sm-inline paginate_button-next-icon"></div>
                    </v-row>
                </a>
            </v-col>
        </v-row>
    </v-row>
</template>


<script>
/* eslint-disable */
export default {
  name: "DiiaDatatableFooter",
  props: ['items_per_page', 'current_page', 'list_size', 'button_text_hidden'],
  data: () => ({
    
  }),
    computed: {
        page_count: function() {
            if (this.list_size && this.items_per_page) {
                return Math.ceil(this.list_size / this.items_per_page);
            }
        },
        items_per_page_input: {
            get: function() {
                return this.items_per_page;
            },
            set: function(newValue) {
                this.$emit('update:items_per_page', newValue);
            }   
        },

        current_page_input: {
            get: function() {
                return this.current_page;
            },
            set: function(newValue) {
                this.$emit('update:current_page', newValue);
            }   
        },
    },

    watch: {
        current_page: {
            handler () {
                window.scrollTo(0, 0);
                this.$emit('on-update');
            },
        },

        items_per_page: {
            handler () {
                window.scrollTo(0, 0);
                if (this.current_page != 1)
                    this.$emit('update:current_page', 1);
                else
                    this.$emit('on-update');
            },
        }
    },

    methods: {
        paginationPrevPage() {
            if (this.current_page > 1)
                this.$emit('update:current_page', this.current_page - 1);
        },

        paginationNextPage() {
            if (this.current_page < this.page_count)
                this.$emit('update:current_page', this.current_page + 1);
        },
    }
}
</script>